var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['block-inner', _vm.blockStyle]},[(_vm.iconComponent)?_c(_vm.iconComponent,{tag:"component",staticClass:"style-icon",attrs:{"width":32,"height":32}}):_vm._e(),_c('div',{domProps:{"innerHTML":_vm._s(_vm.blockContent)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }